<template>
  <ContentWrap>
    <el-form :inline="true" :model="query" class="-mb-15px" @submit.prevent>
      <el-form-item v-if="userMode" label="用户昵称">
        <el-input
          v-model="query.userNickname"
          clearable
          class="!w-180px"
          placeholder="请输入用户昵称"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item label="标题">
        <el-input
          v-model="query.keyword"
          clearable
          class="!w-220px"
          placeholder="请输入标题"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="query.categoryId" clearable class="!w-160px" placeholder="请选择类型">
          <el-option
            v-for="item in categories"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker
          v-model="publishRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          class="!w-360px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">
          <Icon icon="ep:search" class="mr-5px" />查询
        </el-button>
        <el-button @click="reset"><Icon icon="ep:refresh" class="mr-5px" />重置</el-button>
        <el-button
          v-if="!userMode"
          v-hasPermi="[updatePermission]"
          type="primary"
          @click="openEditor()"
        >
          <Icon icon="ep:plus" class="mr-5px" />发布文章
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-tabs v-if="userMode" v-model="query.auditStatus" @tab-change="changeAuditTab">
      <el-tab-pane :label="`待审核 ${auditCounts[0]}`" :name="0" />
      <el-tab-pane :label="`已通过 ${auditCounts[1]}`" :name="1" />
      <el-tab-pane :label="`已驳回 ${auditCounts[2]}`" :name="2" />
    </el-tabs>
    <div class="mb-12px">
      <el-button
        v-if="userMode && query.auditStatus === 0"
        v-hasPermi="['bosscircle:user-news:audit']"
        type="success"
        plain
        :disabled="!selectedRows.length"
        @click="batchAudit(1)"
      >
        <Icon icon="ep:circle-check" class="mr-5px" />批量通过
      </el-button>
      <el-button
        v-if="userMode && query.auditStatus === 0"
        v-hasPermi="['bosscircle:user-news:audit']"
        type="danger"
        plain
        :disabled="!selectedRows.length"
        @click="batchAudit(2)"
      >
        <Icon icon="ep:circle-close" class="mr-5px" />批量驳回
      </el-button>
      <el-button
        v-hasPermi="[updatePermission]"
        type="success"
        plain
        :disabled="!selectedRows.length"
        @click="batchStatus(1)"
      >
        <Icon icon="ep:circle-check" class="mr-5px" />批量启用
      </el-button>
      <el-button
        v-hasPermi="[updatePermission]"
        type="warning"
        plain
        :disabled="!selectedRows.length"
        @click="batchStatus(0)"
      >
        <Icon icon="ep:circle-close" class="mr-5px" />批量禁用
      </el-button>
      <el-button
        v-hasPermi="[deletePermission]"
        type="danger"
        plain
        :disabled="!selectedRows.length"
        @click="deleteSelected"
      >
        <Icon icon="ep:delete" class="mr-5px" />批量删除
      </el-button>
      <span v-if="selectedRows.length" class="ml-10px text-12px text-#909399">
        已选择 {{ selectedRows.length }} 项
      </span>
    </div>
    <el-table
      v-loading="loading"
      :data="list"
      row-key="id"
      @selection-change="selectedRows = $event"
    >
      <el-table-column type="selection" width="45" />
      <el-table-column
        v-if="userMode"
        prop="publisherNickname"
        label="用户昵称"
        min-width="130"
        show-overflow-tooltip
      />
      <el-table-column label="封面图片" width="100">
        <template #default="{ row }">
          <el-image
            v-if="row.newsCover"
            :src="row.newsCover"
            :preview-src-list="[row.newsCover]"
            class="!h-52px !w-72px rounded"
            fit="cover"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="newsTitle" label="标题" min-width="220" show-overflow-tooltip />
      <el-table-column label="类型" width="110">
        <template #default="{ row }">{{ categoryName(row.categoryId) }}</template>
      </el-table-column>
      <el-table-column prop="source" label="来源" min-width="140" show-overflow-tooltip />
      <el-table-column prop="viewCount" label="浏览数" width="90" />
      <el-table-column v-if="userMode" label="审核状态" width="100">
        <template #default="{ row }">
          <el-tag
            :type="row.auditStatus === 1 ? 'success' : row.auditStatus === 2 ? 'danger' : 'warning'"
          >
            {{ auditText(row.auditStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template #default="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'">
            {{ row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="发布时间" width="180" :formatter="dateFormatter" />
      <el-table-column label="操作" :width="userMode ? 360 : 260" fixed="right">
        <template #default="{ row }">
          <el-button v-hasPermi="[updatePermission]" link type="primary" @click="openEditor(row)"
            >编辑</el-button
          >
          <el-button link type="primary" @click="openDetail(row)">详情</el-button>
          <el-button
            v-hasPermi="[updatePermission]"
            link
            :type="row.status === 1 ? 'warning' : 'success'"
            @click="setStatus(row)"
          >
            {{ row.status === 1 ? '禁用' : '启用' }}
          </el-button>
          <el-button
            v-if="userMode && row.auditStatus === 0"
            v-hasPermi="['bosscircle:user-news:audit']"
            link
            type="warning"
            @click="openAudit(row)"
            >审核</el-button
          >
          <el-button v-hasPermi="[deletePermission]" link type="danger" @click="deleteOne(row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="editorVisible" :title="form.id ? '编辑文章' : '发布文章'" width="860px">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="标题" prop="newsTitle"
        ><el-input v-model="form.newsTitle"
      /></el-form-item>
      <el-form-item label="封面"><UploadImg v-model="form.newsCover" /></el-form-item>
      <el-form-item label="类型" prop="categoryId">
        <el-select v-model="form.categoryId" class="!w-220px">
          <el-option
            v-for="item in categories"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="来源"><el-input v-model="form.source" /></el-form-item>
      <el-form-item label="内容" prop="newsContent">
        <Editor v-model="form.newsContent" height="320px" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="editorVisible = false">取消</el-button>
      <el-button type="primary" @click="save">发布</el-button>
    </template>
  </Dialog>

  <Dialog
    v-model="detailVisible"
    :title="auditMode ? '用户动态审核' : '文章详情'"
    width="820px"
  >
    <el-descriptions v-if="detail" :column="2" border class="mb-16px">
      <el-descriptions-item label="标题" :span="2">{{ detail.newsTitle }}</el-descriptions-item>
      <el-descriptions-item label="类型">{{
        categoryName(detail.categoryId)
      }}</el-descriptions-item>
      <el-descriptions-item label="来源">{{ detail.source || '-' }}</el-descriptions-item>
      <el-descriptions-item label="浏览数">{{ detail.viewCount || 0 }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{
        detail.status === 1 ? '启用' : '禁用'
      }}</el-descriptions-item>
      <el-descriptions-item label="发布时间">{{
        formatDate(detail.createTime)
      }}</el-descriptions-item>
      <el-descriptions-item label="审核状态">{{
        auditText(detail.auditStatus)
      }}</el-descriptions-item>
      <el-descriptions-item label="封面" :span="2">
        <el-image
          v-if="detail.newsCover"
          :src="detail.newsCover"
          :preview-src-list="[detail.newsCover]"
          class="!h-110px !w-160px rounded"
          fit="cover"
        />
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="内容" :span="2">
        <div class="news-detail" v-html="detail.newsContent || '-'"></div>
      </el-descriptions-item>
    </el-descriptions>
    <template v-if="auditMode && detail?.auditStatus === 0">
      <el-divider content-position="left">审核操作</el-divider>
      <el-form label-width="96px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditForm.pass">
            <el-radio :value="true">通过</el-radio>
            <el-radio :value="false">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!auditForm.pass" label="驳回原因" required>
          <el-input
            v-model="auditForm.remark"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="请填写驳回原因"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="detailVisible = false">{{ auditMode ? '取消' : '关闭' }}</el-button>
      <el-button
        v-if="auditMode && detail?.auditStatus === 0"
        type="primary"
        :loading="auditForm.saving"
        @click="submitAudit"
        >提交审核</el-button
      >
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import * as Api from '@/api/business/news'
import * as CategoryApi from '@/api/business/newsCategory'
import { dateFormatter, formatDate } from '@/utils/formatTime'

defineOptions({ name: 'BossCircleNews' })

const message = useMessage()
const route = useRoute()
const userMode = computed(() => route.path.includes('/circle/news'))
const updatePermission = computed(() =>
  userMode.value ? 'bosscircle:user-news:update' : 'bosscircle:news:update'
)
const deletePermission = computed(() =>
  userMode.value ? 'bosscircle:user-news:delete' : 'bosscircle:news:delete'
)
const loading = ref(false)
const list = ref<any[]>([])
const categories = ref<any[]>([])
const selectedRows = ref<any[]>([])
const auditCounts = reactive<Record<number, number>>({ 0: 0, 1: 0, 2: 0 })
const auditMode = ref(false)
const auditForm = reactive({ pass: true, remark: '', saving: false })
const total = ref(0)
const editorVisible = ref(false)
const detailVisible = ref(false)
const formRef = ref()
const publishRange = ref<string[]>([])
const detail = ref<any>()
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  keyword: '',
  userNickname: '',
  categoryId: undefined as number | undefined,
  publisherType: 1,
  auditStatus: userMode.value ? 0 : (undefined as number | undefined)
})
const form = reactive<any>({})
const rules = {
  newsTitle: [{ required: true, message: '请输入标题' }],
  categoryId: [{ required: true, message: '请选择类型' }],
  newsContent: [{ required: true, message: '请输入内容' }]
}
const auditText = (value: number) => ['待审核', '已通过', '已驳回'][value] || '-'
const categoryName = (id: number) =>
  categories.value.find((item) => item.id === id)?.categoryName || id || '-'
const load = async () => {
  loading.value = true
  try {
    const data = await Api.getNewsPage(
      {
        ...query,
        createTimeStart: publishRange.value?.[0],
        createTimeEnd: publishRange.value?.[1]
      },
      userMode.value
    )
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const loadAuditCounts = async () => {
  if (userMode.value) Object.assign(auditCounts, await Api.getNewsAuditCounts())
}
const changeAuditTab = (name: string | number) => {
  query.auditStatus = Number(name)
  query.pageNo = 1
  selectedRows.value = []
  load()
}
const reset = () => {
  query.pageNo = 1
  query.keyword = ''
  query.userNickname = ''
  query.categoryId = undefined
  publishRange.value = []
  load()
}
const openEditor = (row: any = {}) => {
  Object.assign(
    form,
    {
      id: undefined,
      newsTitle: '',
      newsContent: '',
      newsCover: '',
      categoryId: categories.value[0]?.id,
      source: '',
      publisherType: 1,
      auditStatus: 1,
      status: 1
    },
    row
  )
  form.publisherType = 1
  form.auditStatus = 1
  editorVisible.value = true
}
const save = async () => {
  if (!(await formRef.value?.validate().catch(() => false))) return
  await Api.saveNews({ ...form, publisherType: userMode.value ? 2 : 1 }, userMode.value)
  editorVisible.value = false
  message.success('发布成功')
  await load()
}
const openDetail = async (row: any) => {
  auditMode.value = false
  detail.value = await Api.getNews(row.id, userMode.value)
  detailVisible.value = true
}
const openAudit = async (row: any) => {
  auditMode.value = true
  auditForm.pass = true
  auditForm.remark = ''
  detail.value = await Api.getNews(row.id, userMode.value)
  detailVisible.value = true
}
const submitAudit = async () => {
  if (!detail.value?.id) return
  if (!auditForm.pass && !auditForm.remark.trim()) {
    message.warning('请填写驳回原因')
    return
  }
  auditForm.saving = true
  try {
    await Api.auditNews(
      detail.value.id,
      auditForm.pass ? 1 : 2,
      auditForm.pass ? undefined : auditForm.remark.trim(),
      true
    )
    message.success(auditForm.pass ? '已通过' : '已驳回')
    detailVisible.value = false
    await Promise.all([load(), loadAuditCounts()])
  } finally {
    auditForm.saving = false
  }
}
const setStatus = async (row: any) => {
  const status = row.status === 1 ? 0 : 1
  await message.confirm(`确认${status === 1 ? '启用' : '禁用'}该文章吗？`)
  await Api.updateNewsStatus(row.id, status, userMode.value)
  message.success('操作成功')
  await load()
}
const batchStatus = async (status: number) => {
  await message.confirm(
    `确认${status === 1 ? '启用' : '禁用'}选中的 ${selectedRows.value.length} 篇文章吗？`
  )
  await Api.batchUpdateNewsStatus(
    selectedRows.value.map((item) => item.id),
    status,
    userMode.value
  )
  selectedRows.value = []
  message.success('批量操作成功')
  await load()
}
const deleteOne = async (id: number) => {
  await message.delConfirm('确认删除该文章吗？评论和点赞数据将保留。')
  await Api.deleteNews(id, userMode.value)
  message.success('删除成功')
  await Promise.all([load(), loadAuditCounts()])
}
const deleteSelected = async () => {
  await message.delConfirm(
    `确认删除选中的 ${selectedRows.value.length} 篇文章吗？评论和点赞数据将保留。`
  )
  await Api.batchDeleteNews(
    selectedRows.value.map((item) => item.id),
    userMode.value
  )
  selectedRows.value = []
  message.success('批量删除成功')
  await Promise.all([load(), loadAuditCounts()])
}

const getAuditRemark = async (auditStatus: number, count?: number) => {
  if (auditStatus === 2) {
    return (await message.prompt('请输入驳回原因', count ? `批量驳回 ${count} 条动态` : '驳回动态'))
      .value
  }
  await message.confirm(count ? `确认批量通过选中的 ${count} 条动态吗？` : '确认通过该动态吗？')
  return undefined
}
const batchAudit = async (auditStatus: number) => {
  const ids = selectedRows.value.map((item) => item.id)
  if (!ids.length) return
  const auditRemark = await getAuditRemark(auditStatus, ids.length)
  await Api.batchAuditNews(ids, auditStatus, auditRemark)
  selectedRows.value = []
  message.success('批量审核成功')
  await Promise.all([load(), loadAuditCounts()])
}

onMounted(async () => {
  categories.value = await CategoryApi.getCategoryList(userMode.value ? 2 : 1, userMode.value)
  await Promise.all([load(), loadAuditCounts()])
})
</script>

<style scoped lang="scss">
.news-detail {
  max-height: 360px;
  overflow: auto;
  line-height: 1.7;
  word-break: break-word;

  :deep(img) {
    max-width: 100%;
    height: auto;
    display: block;
  }
}
</style>
